/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'price': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M0 11.365V2.156C0 .988.943 0 2.156 0h9.164c.584 0 1.123.27 1.528.674l9.478 9.478c.854.854.854 2.246 0 3.055l-9.164 9.164c-.809.854-2.201.854-3.055 0L.63 12.893A2.14 2.14 0 010 11.365zm5.031-8.49a2.157 2.157 0 00-2.156 2.156c0 1.213.943 2.157 2.156 2.157A2.157 2.157 0 007.188 5.03c0-1.168-.989-2.156-2.157-2.156z" _fill="#3E4749"/>'
  }
})
